/*
 *		Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('SyncAndShareNodesController', [
        '$modalStack',
        '$routeParams',
        '$scope',
        'FILE_DROP_EVENT',
        'FILE_UPLOAD_MODAL_EVENT',
        'FileUploadModal',
        'headerService',
        'nodeConfirmSync',
        'Settings',
        'SyncAndShareNode',
        function (
            $modalStack,
            $routeParams,
            $scope,
            FILE_DROP_EVENT,
            FILE_UPLOAD_MODAL_EVENT,
            FileUploadModal,
            headerService,
            nodeConfirmSync,
            Settings,
            SyncAndShareNode
        ) {
            $scope.table = {
                model: SyncAndShareNode,
                perPage: 100,
                supportsSearch: true,
                searchPreloadCount: 50
            };

            $scope.contentStats = _initContentStats();
            $scope.basePath = headerService.basePath = '#nodes';
            $scope.showStatusColumn = Settings['cloud_platform_notarization_enabled'] || Settings['cloud_platform_sign_files_enabled'];

            $scope.currentNode = SyncAndShareNode.get({ uuid: ($routeParams.uuid || 0) }, function (currentNode) {
                headerService.populateBreadcrumbs(currentNode, $scope.basePath);

                nodeConfirmSync(currentNode);
            });

            $scope.$on(FILE_UPLOAD_MODAL_EVENT.CLOSED, function (_, stat) {
                if (stat.success > 0) {
                    $scope.$broadcast('reload.dataTable');
                }
            });

            $scope.$on('reload.contentStats', function () {
                SyncAndShareNode
                    .get({ uuid: ($routeParams.uuid || 0), fields: 'content_stats' })
                    .$promise
                    .then(function (data) {
                        $scope.currentNode.content_stats = data.content_stats;
                    });
            });

            $scope.$on('$destroy', function () {
                $scope.currentNode.$cancelRequest();
            });

            $scope.$on(FILE_DROP_EVENT.DROPPED, _onFilesDropHandler);

            function _initContentStats() {
                var folderCount = 0,
                    fileCount = 0,
                    shownCount = 0;

                return Object.defineProperties({}, {
                    folders: {
                        get: function () {
                            if ($scope.currentNode.content_stats && !$scope.table.loading) {
                                folderCount = $scope.currentNode.content_stats.folders_active;

                                if ($scope.table.areDeletedShown()) {
                                    folderCount += $scope.currentNode.content_stats.folders_deleted;
                                }

                                return folderCount;
                            } else {
                                return folderCount;
                            }
                        }
                    },
                    files: {
                        get: function () {
                            if ($scope.currentNode.content_stats && !$scope.table.loading) {
                                fileCount = $scope.currentNode.content_stats.files_active;

                                if ($scope.table.areDeletedShown()) {
                                    fileCount += $scope.currentNode.content_stats.files_deleted;
                                }

                                return fileCount;
                            } else {
                                return fileCount;
                            }
                        }
                    },
                    total: {
                        get: function () {
                            return fileCount + folderCount;
                        }
                    },
                    shown: {
                        get: function () {
                            if ($scope.table.filteredEntries && !$scope.table.loading) {
                                shownCount = $scope.table.filteredEntries.length;

                                return shownCount;
                            } else {
                                return shownCount;
                            }
                        }
                    }
                });
            }

            function _onFilesDropHandler(_, target, dataTransfer) {
                // Prevent calling handler if a modal window is opened, i.e. File Upload modal
                if (angular.isUndefined($modalStack.getTop())) {
                    FileUploadModal(target, dataTransfer);
                }
            }
        }
    ]);
